export default {
      id: "plus-usage",
      viewBox: "0 0 29.119 29.119",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#plus",
      toString: function () {
        return this.url;
      }
    }